











































import Vue from 'vue';
import userClient from '../apis';
import { AuthStatusCode } from '../models/Login';
import userVuex from '../vuex/common';
import { getCookie } from '@/common/utils/Http';

const authUrl: string | null = null;
const status: string | null = null;
const weixinName: string | null = null;
const authCode: number | undefined = undefined;
const bindEmail: number | null = null;

export default Vue.extend({
  mixins: [userVuex],
  data() {
    return {
      callback: '',
      authType: 1,
      status,
      inited: false,
      authCode,
      bindEmail,
      delay: 3,
      AuthStatusCode,
      weixinName,
    };
  },
  methods: {
    getAuthStatus() {
      userClient.authStatus({
        status: this.status,
      }).success((r) => {
        this.authCode = r.code;
        this.updateAccount(r.account);
        this.bindEmail = r.bindEmail;
        this.weixinName = r.weixinName;
        this.inited = true;
        this.setDelay(r.code);
      }).error((r) => {
        this.authCode = AuthStatusCode.Error;
        this.inited = true;
      });
    },
    updateAccount(account: any) {
      if (account) {
        window.localStorage.setItem('account', JSON.stringify(account));
        this.$store.commit('UPDATE_ACCOUNT', account);
      }
    },
    setDelay(authCode: number) {
      if (authCode === AuthStatusCode.Ok || authCode === AuthStatusCode.AuthRefresh) {
        const downCountInterval = setInterval(() => {
          this.delay = this.delay - 1;
          if (this.delay <= 0) {
            clearInterval(downCountInterval);
            window.location.href = '#/customer/search';
          }
        }, 1000);
      }
    },
    authWx() {
      window.location.href = 'https://weixin.drip.im/wx-member/auth?origin=' + encodeURIComponent('http://crm.drip.im/api-crm-web/auth/dripCrmAuthCallback') + '&authType=1';
    },
    loginOut() {
      userClient.loginOut({}).success((r) => {
        window.localStorage.removeItem('account');
        this.$store.commit('LOGIN_OUT');
        window.location.href = '#/user/login';
      }).error((r) => {
        this.$Message.error(r);
      });
    },
  },
  mounted() {
    if (!getCookie('DRIP_SESSION_KEY_USER_IDENTITY')) {
      window.location.href = '#/user/login';
    } else {
      if (this.account && this.account.id && this.account.isCompValid && !this.$route.query.result) {
        window.location.href = '#/customer/search';
      } else {
        if (this.$route.query.result) {
          this.status = this.$route.query.result as string;
          this.getAuthStatus();
        } else {
          this.inited = true;
        }
      }
    }
  },
});
